import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
import * as auth from "../../common/helpers/auth";

export class UserViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getUsers = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var userResponse = await this.getUserListByCodeTag();
    if (
      Format.isNotNull(userResponse.errorCode) &&
      userResponse.errorCode === 0
    ) {
      if (Format.isNotNull(userResponse.users)) {
        this.updateState("userList", userResponse.users);
        this.logger.info(userResponse.users);
      } else {
        this.showEmpty("User");
      }
    } else {
      this.showError("User", CrudlStatus.LIST);
    }
  };

  getUsersReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var userResponse = await this.getUserListByCodeTag();
    if (
      Format.isNotNull(userResponse.errorCode) &&
      userResponse.errorCode === 0
    ) {
      if (Format.isNotNull(userResponse.users)) {
        this.logger.info(userResponse.users);
        return userResponse.users;
      } else {
        this.showEmpty("User");
      }
    } else {
      this.showError("User", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (users, apiResponse, type, externalStateValues) => {
    var updatedUserList = [];
    if (type === CrudlStatus.CREATE) {
      updatedUserList = this.reloadAfterCreate(
        users,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedUserList = this.reloadAfterUpdate(
        users,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedUserList = this.reloadAfterDelete(
        users,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("userList", updatedUserList);
  };

  reloadAfterCreate = (userList, apiResponse, externalStateValues) => {
    if (userList === undefined || userList === null) {
      userList = [];
    }
    var userBean = externalStateValues.userBean;
    userBean.id = apiResponse.id;
    userBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    userList.push(userBean);

    return userList;
  };

  reloadAfterUpdate = (userList, apiResponse, externalStateValues) => {
    var i = 0;
    userList.forEach(e => {
      if (apiResponse.id === e.id) {
        userList[i] = externalStateValues.userBean;
        userList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return userList;
  };

  reloadAfterDelete = (userList, apiResponse, externalStateValues) => {
    var i = 0;
    userList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        userList.splice(i, 1);
      }
      i++;
    });

    return userList;
  };

  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let userRequest = CloudService.UserRequest.constructFromObject(
      stateVariables.userBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createUser(userRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateUser(userRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteUser(userRequest);
    }
  };

  addUserFirebase = async email => {
    try {
      await auth.auth(email, "password");
      await auth.resetPassword(email);
    } catch (error) {
      //Not Essential here so want to prevent this from causing an issue
    }
  };

  createUser = async (userRequest, stateVariables) => {
    userRequest.codeTag = this.codeTag;
    userRequest.userId = this.userId;
    //HARDCODE TEMPORARY
    userRequest.roleType = 10;

    let userResponse = await ApiService.userCreate(userRequest);
    await this.addUserFirebase(userRequest.email);
    if (userResponse.errorCode === 0) {
      this.showSuccess("User", CrudlStatus.CREATE);
    } else {
      this.showError("User", CrudlStatus.CREATE);
    }

    return userResponse;
  };

  deleteUser = async userRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = userRequest.id;
    request.lastUpdatedDateTime = userRequest.lastUpdatedDateTime;

    let userResponse = await ApiService.userDelete(request);
    if (userResponse.errorCode === 0) {
      this.showSuccess("User", CrudlStatus.DELETE);
    } else {
      this.showError("User", CrudlStatus.DELETE);
    }

    return userResponse;
  };

  updateUser = async (userRequest, stateVariables) => {
    userRequest.codeTag = this.codeTag;
    userRequest.userId = this.userId;

    let userResponse = await ApiService.userUpdate(userRequest);
    if (userResponse.errorCode === 0) {
      this.showSuccess("User", CrudlStatus.UPDATE);
    } else {
      this.showError("User", CrudlStatus.UPDATE);
    }

    return userResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/User/UserViewModel.js